export enum AuthRoutesEnum {
    SIGN_IN             = 'signin',
    SIGN_UP             = 'signup',
    FORGOTTEN_PWD       = 'forgottenPassword',
    RESET_PWD           = 'resetPassword',
    CURRENT_USER        = 'current-user',
    VALIDATE_USER       = 'validate-user',
    BUSINESS_PROFILE    = 'business-profile'
}